module.exports = __webpack_public_path__ + "static/img/13.aa32c5c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/8/1/sp/13.png
// module id = X/DG
// module chunks = 0